class Loading {
    constructor(parent) {
        if (typeof parent === "undefined") {
            parent = document.querySelector("body");
        }
        this.parent = parent;
        this.elem = document.createElement("loading");
        this.showTimeout = null;
    }

    show(delay = 500) {
        this.parent.appendChild(this.elem);
        this.showTimeout = setTimeout(() => {
            if (typeof this.elem === "object") {
                if (!this.parent.style.position) {
                    this.parent.style.position = "relative";
                }
                this.elem.style.opacity = "1"
            }
        }, delay);
    }

    hide() {
        clearTimeout(this.showTimeout);
        if (typeof this.elem === "object") {
            this.elem.style.opacity = "0";
            setTimeout(() => {
                this.elem.remove();
            }, 500);
        }
    }
}
